import React from 'react';

import Textarea from 'components/fields/Textarea';
import File from 'components/fields/File';
import Radio from 'components/fields/Radio';

const FormQuestion = props => {
  switch (props.type) {
    case 'image':
      return <File {...props} maxSize={3.5} />;
    case 'video':
      return <File {...props} />;
    case 'radio':
      return <Radio {...props} />;
    default:
      return <Textarea {...props} />;
  }
};

export default FormQuestion;
